import React from 'react';
import './Button.css';

const Button = ({ 
  text, 
  onClick, 
  variant = 'primary', // 'primary' (solid) or 'outline'
  size = 'md', 
  showArrow = true, 
  className = '' 
}) => {
  return (
    <button 
      className={`custom-btn ${variant} ${size} ${className}`} 
      onClick={onClick}
    >
      <span className="btn-text">{text}</span>
      {showArrow && (
        <span className="btn-arrow-container">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
              d="M5 12H19M19 12L13 6M19 12L13 18" 
              stroke="currentColor" 
              strokeWidth="2.9" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}
    </button>
  );
};

export default Button;